import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
import { FlowVis } from '../adhoc/blog/all-wrapped.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`found a simple graph visualizer to give a try ...`}</p>
    <h1>{`Simple`}</h1>
    <p>{`I used to make `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/12ku-mqtJtsGfC8rbUQUMC2GTXgjWDHhl/view?usp=sharing"
      }}>{`fancy graph`}</a>{` for visualization apps. But sometimes I just want something simple, browser accessible and enable me to quickly visualize some json DAG or flow chart. Got this nice workflow visualizer from github (`}<a parentName="p" {...{
        "href": "https://github.com/d-band/flow-kit"
      }}>{`Flow-Kit`}</a>{`) and happy to use it as a tool. Also thanks to excellent react json viewer (`}<a parentName="p" {...{
        "href": "https://github.com/mac-s-g/react-json-view"
      }}>{`rjv`}</a>{`). Now we have this graph visualizer takes simple json 🎉🎉🎉.`}</p>
    <FlowVis mdxType="FlowVis" />
    <p>{`Oh, it actually just requires informal JSON as we usually write in Javascript which means you don't need to use double quotes for keys!`}</p>
    <h1>{`Next`}</h1>
    <p>{`Next I want it to be flexible for all json format: I can visciously `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`eval`}</code>{` a Javascript snippet for converting any data or json into the correct format.`}</p>
    <p>{`TODO:`}</p>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`Fix exception`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`Fix duplicate edge issue`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Add eval to input`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Add debounce for input change`}</li>
    </ul>
    <h1>{`Further`}</h1>
    <p>{`Make url take parameters of json format... a crappy jump link visualizer 😂`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      